module.exports = __webpack_public_path__ + "static/media/top-img_7@2x.bb6efe79.jpg";